{
  "fr": {
    "onboarding": {
      "steps": {
        "name": {
          "heading": "Quel est ton nom ?",
          "headingInternational": "Bienvenue à bord !",
          "paragraph": "Nous avons besoin de ton vrai nom pour les certificats de participation.",
          "paragraphInternational": "Merci de nous indiquer ton nom.",
          "submit": "Continuer"
        },
        "international": {
          "heading": "Quels sont les services qui t'intéressent ?",
          "submit": "Continuer",
          "options": {
            "false": "Offres en allemand 🇩🇪 🇦🇹 🇨🇭",
            "true": "Offres en anglais 🌎"
          },
          "descriptions": {
            "false": "Recommandé pour les personnes parlant allemand (plus grand choix de formations)",
            "true": "Recommandé pour les personnes ne parlant pas allemand"
          }
        },
        "job": {
          "heading": "Quel est le rôle qui te décrit le mieux ?",
          "paragraph": "Je suis...",
          "submit": "Continuer",
          "skip": "Remplir plus tard"
        },
        "company": {
          "heading": "Où travailles-tu ?",
          "submit": "Continuer",
          "pleaseSelect": "Veuillez sélectionner un établissement d'enseignement",
          "noResults": "Aucun résultat. Veuillez entrer votre code postal complet."
        },
        "country": {
          "heading": "Dans quel pays travailles-tu ?",
          "paragraph": "Nous souhaitons te fournir le meilleur service pour ta langue et ton système scolaire.",
          "submit": "Continuer"
        },
        "grade": {
          "heading": "Où enseignes-tu ?",
          "paragraph": "Nous proposons des formations et des webinaires pour tous les niveaux et types d'établissements. Ces informations nous aident à te recommander les contenus adaptés.",
          "submit": "Continuer"
        },
        "region": {
          "heading": "Où travailles-tu ?",
          "paragraph": "Avec cette information, tu nous aides à te recommander des informations et des offres spécifiques à ton région.",
          "submit": "Continuer"
        },
        "subject": {
          "heading": "Quelles matières enseignes-tu ?",
          "paragraph": "Nous proposons des formations et des webinaires pour tous les niveaux et types d'établissements. Ces informations nous aident à te recommander les contenus adaptés.",
          "submit": "Continuer"
        },
        "tool": {
          "heading": "Qu'est-ce qui t'intéresse le plus ?",
          "paragraph": "Avec ces préférences, nous pouvons te donner les meilleures recommandations.",
          "submit": "Continuer"
        },
        "infoFrom": {
          "heading": "Ravi de te voir ici !",
          "headingReOnboarding": "C'est tout ! Merci pour tes informations.",
          "subHeading": "Ton inscription a été réussie.",
          "paragraph": "Une dernière question : comment as-tu entendu parler de fobizz ?",
          "submit": "C'est parti"
        }
      },
      "reOnboarding": {
        "heading": "Bienvenue de retour chez fobizz !",
        "paragraph": "Pour te faire des recommandations adaptées, nous te demandons régulièrement si tes informations sont toujours à jour.",
        "thanks": "Merci de prendre un moment pour cela !",
        "start": "C'est parti !",
        "skip": "Pas maintenant"
      },
      "labels": {
        "back": "Retour",
        "or": "ou",
        "skip": "Passer",
        "pleaseSpecify": "Veuillez préciser",
        "companyKind": "Établissement d'enseignement",
        "schoolType": "Type d'école",
        "country": "Pays",
        "zipcode": "Code postal",
        "newCompany": "Mon établissement d'enseignement n'est pas listé",
        "companyName": "Nom de l'établissement d'enseignement (Veuillez écrire en toutes lettres, pas d'abréviation)",
        "customSchoolType": "Autre type d'école",
        "customCompany": "Dans quel établissement travailles-tu ?",
        "street": "Rue, numéro",
        "city": "Ville",
        "searching": "Recherche ...",
        "activate": "Activer"
      },
      "enums": {
        "infoFromType": {
          "school_administration": "Direction de l'école",
          "colleagues": "Collègues",
          "instagram": "Instagram",
          "twitter": "Twitter",
          "facebook": "Facebook",
          "pinterest": "Pinterest",
          "linkedin": "LinkedIn",
          "online_search": "Recherche sur Internet",
          "ai_assistant": "Assistant IA",
          "social_media": "Réseaux sociaux",
          "podcast": "Podcast",
          "event": "Événement, salon ou conférence",
          "custom": "Autre"
        },
        "regionCode": {
          "BW": "Bade-Wurtemberg",
          "BY": "Bavière",
          "BE": "Berlin",
          "BB": "Brandebourg",
          "HB": "Brême",
          "HH": "Hambourg",
          "HE": "Hesse",
          "MV": "Mecklembourg-Poméranie-Occidentale",
          "NI": "Basse-Saxe",
          "NW": "Rhénanie-du-Nord-Westphalie",
          "RP": "Rhénanie-Palatinat",
          "SL": "Sarre",
          "SN": "Saxe",
          "ST": "Saxe-Anhalt",
          "SH": "Schleswig-Holstein",
          "TH": "Thuringe"
        },
        "toolsByValue": {
          "1": "Outils IA",
          "2": "Découvrir du matériel pédagogique",
          "3": "Formations en ligne",
          "4": "Outils IA pour les élèves",
          "5": "Créer son propre matériel pédagogique numérique"
        }
      }
    }
  }
}
